// QL-150 step 4 — read-only display of the recurring orders QP sent the bank
// at flow completion, grouped flow → agreement. Orders are QP-created and
// bank-updated (optional status callback); this surface never edits. A group
// with a null savingsPlanId is history — its agreement was deleted after the
// fact (bank cancellation or placeholder cleanup) — and still renders.
// Same layout as the Orders tab: a collapsible card per completed advice, a
// status filter and Refresh (shared components in components/orders).

export const T = {
  en_GB: {
    empty:
      "No recurring orders yet. They are created when a flow with a savings plan is completed.",
    noOrdersFilter: "No orders match the selected filter.",
    deletedAgreement: "Deleted agreement",
    pendingPlan: "awaiting bank",
    activePlan: "active",
    units: "units",
    product: "Product",
    isin: "ISIN",
    amount: "Amount",
    start: "Start",
    account: "Account",
    status: "Status",
    order: "order",
    orders: "orders",
  },
  nb_NO: {
    empty: "Ingen faste ordrer ennå. De opprettes når en flyt med spareavtale fullføres.",
    noOrdersFilter: "Ingen ordrer samsvarer med det valgte filteret.",
    deletedAgreement: "Slettet avtale",
    pendingPlan: "venter på bank",
    activePlan: "aktiv",
    units: "andeler",
    product: "Produkt",
    isin: "ISIN",
    amount: "Beløp",
    start: "Start",
    account: "Konto",
    status: "Status",
    order: "ordre",
    orders: "ordrer",
  },
} as const;
